RivalIQ.apps.Admin.module('models', function (models, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    models.Invoice = Backbone.Model.extend({

        initialize: function (data) {
            const me = this;
            me.urlRoot = `/admin/api/accounts/${data.account_id}/invoices`;
        },

        isPastDue: function () {
            const me = this;
            return (me.get('is_stripe') && !me.get('is_upcoming') && !me.get('stripe_invoice_data').paid);
        },

        validate: function (data) {

            const errors = [];

            if (!data.invoice_period_start) {
                errors.push(['invoice_period_start', 'Invoice period start is required']);
            }

            if (!data.invoice_period_end) {
                errors.push(['invoice_period_end', 'Invoice period end is required']);
            }

            if (data.invoice_period_start && data.invoice_period_end &&
                moment.utc(data.invoice_period_end).isBefore(moment.utc(data.invoice_period_start))) {
                errors.push(['invoice_period_end', 'Invoice period end must be after the start']);
            }

            if (!data.invoice_monthly_revenue) {
                errors.push(['invoice_monthly_revenue', 'Invoice MRR is required']);
            }

            if (!data.invoice_total) {
                errors.push(['invoice_total', 'Invoice total value is required']);
            }

            if (!data.invoice_tax) {
                errors.push(['invoice_tax', 'Invoice sales tax value is required']);
            }

            return (errors.length ? errors : null);
        },

        serialize: function () {

            const me = this;

            // data coercion: fix up timezones, clean up dollars, etc.
            return _.assign({}, me.attributes, {
                invoice_period_start: moment.utc(me.get('invoice_period_start')).format('YYYY-MM-DD'),
                invoice_period_end: moment.utc(me.get('invoice_period_end')).format('YYYY-MM-DD'),
                invoice_monthly_revenue: me.get('invoice_monthly_revenue').replace(/[^0-9.]+/g, ''),
                invoice_total: me.get('invoice_total').replace(/[^0-9.]+/g, ''),
                invoice_tax: me.get('invoice_tax').replace(/[^0-9.]+/g, ''),
                plan_id: (me.get('plan_id') || null),
                revenue_type: (me.get('revenue_type') || null),
                nbq_revenue_type_id: (me.get('nbq_revenue_type_id') || null)
            });
        }

    });

}, window.moment);
